<template>
    <div
        :class="
            user_selected_values.length > 3
                ? 'color_slider owl-carousel'
                : 'color_slider carousel_center_minimum'
        "
    >
        <div
            v-for="(product_colors, index) in user_selected_values"
            :key="product_colors.color_id"
        >
            <div
                class="thumb_slider_footer"
                v-if="build_item_id && index == activeColorIndex"
            >
                <div
                    v-if="product_colors.swatches"
                    class="design_studio_footer_change_color_images t_shirt_slide_color"
                    :id="
                        't-shirt-' +
                        product_colors.color_hash +
                        't-shirt-' +
                        product_colors.color_id
                    "
                    :class="activeClass(product_colors)"
                >
                    <span
                        class="color_images_cross_icon"
                        v-if="activeClass(product_colors)"
                    >
                        <a href="javascript:;" data-original-title="" title="">
                            <img
                                src="/maincss/design-studio/img/check.png"
                                alt="cross icon"
                            />
                        </a>
                    </span>
                    <img
                        class="multi-swatches"
                        :src="product_colors.swatches"
                    />
                </div>

                <div
                    v-else
                    class="design_studio_footer_change_color_images t_shirt_slide_color"
                    :id="
                        't-shirt-' +
                        product_colors.color_hash +
                        't-shirt-' +
                        product_colors.color_id
                    "
                    :class="activeClassHex(product_colors)"
                >
                    <span
                        class="color_images_cross_icon"
                        v-if="activeClassHex(product_colors)"
                    >
                        <a href="javascript:;" data-original-title="" title="">
                            <img
                                src="/maincss/design-studio/img/check.png"
                                alt="cross icon"
                            />
                        </a>
                    </span>
                    <svg
                        version="1.0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="35.000000pt"
                        height="35.000000pt"
                        viewBox="0 0 35.000000 35.000000"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <g
                            transform="translate(0.000000,35.000000) scale(0.100000,-0.100000)"
                            fill="#000000"
                            stroke="none"
                        >
                            <path
                                :fill="product_colors.color_hash"
                                d="M0 175 l0 -175 175 0 175 0 0 175 0 175 -175 0 -175 0 0 -175z"
                            />
                        </g>
                    </svg>
                </div>
            </div>
            <div v-else-if="!build_item_id" class="thumb_slider_footer">
                <div
                    v-if="product_colors.swatches"
                    class="design_studio_footer_change_color_images t_shirt_slide_color"
                    :id="
                        't-shirt-' +
                        product_colors.color_hash +
                        't-shirt-' +
                        product_colors.color_id
                    "
                    :class="activeClass(product_colors)"
                >
                    <span
                        class="color_images_cross_icon"
                        v-if="activeClass(product_colors)"
                    >
                        <a href="javascript:;" data-original-title="" title="">
                            <img
                                src="/maincss/design-studio/img/check.png"
                                alt="cross icon"
                            />
                        </a>
                    </span>
                    <img
                        class="multi-swatches"
                        :src="product_colors.swatches"
                    />
                </div>

                <div
                    v-else
                    class="design_studio_footer_change_color_images t_shirt_slide_color"
                    :id="
                        't-shirt-' +
                        product_colors.color_hash +
                        't-shirt-' +
                        product_colors.color_id
                    "
                    :class="activeClassHex(product_colors)"
                >
                    <span
                        class="color_images_cross_icon"
                        v-if="activeClassHex(product_colors)"
                    >
                        <a href="javascript:;" data-original-title="" title="">
                            <img
                                src="/maincss/design-studio/img/check.png"
                                alt="cross icon"
                            />
                        </a>
                    </span>
                    <svg
                        version="1.0"
                        xmlns="http://www.w3.org/2000/svg"
                        width="35.000000pt"
                        height="35.000000pt"
                        viewBox="0 0 35.000000 35.000000"
                        preserveAspectRatio="xMidYMid meet"
                    >
                        <g
                            transform="translate(0.000000,35.000000) scale(0.100000,-0.100000)"
                            fill="#000000"
                            stroke="none"
                        >
                            <path
                                :fill="product_colors.color_hash"
                                d="M0 175 l0 -175 175 0 175 0 0 175 0 175 -175 0 -175 0 0 -175z"
                            />
                        </g>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ColorOwlCarousel",
    props: ["user_selected_values", "activeColorIndex", "build_item_id"],
    data() {
        return {
            isBusy: false
        };
    },
    computed: {},
    components: {},

    mounted() {
        let timer = 4000;
        /* eslint-disable */
        if (this.user_selected_values.length > 3) {
            setTimeout(() => {
                $(".owl-carousel").owlCarousel({
                    loop: false,
                    // stagePadding: 0,
                    autoWidth: true,
                    margin: 8,
                    autoplay: false,
                    autoplayTimeout: 4000,
                    autoplayHoverPause: false,
                    responsiveClass: true,
                    responsive: {
                        0: {
                            items: 6,
                            nav: true
                        },
                        360: {
                            items: 6,
                            nav: true
                        },
                        600: {
                            items: 5,
                            nav: true
                        },
                        767: {
                            items: 6,
                            nav: true
                            // loop: true,
                        },
                        1024: {
                            items: 2,
                            nav: true
                            // loop: false
                        },
                        1280: {
                            items: 6,
                            nav: true
                            // loop: false
                        },
                        1366: {
                            items: 6,
                            nav: true
                            // loop: true
                        },
                        1440: {
                            items: 6,
                            nav: true
                            // loop: true
                        },
                        1441: {
                            items: 6,
                            nav: true
                            // loop: true
                        }
                    }
                });
                $(".play").on("click", function () {
                    owl.trigger("play.owl.autoplay", [1000]);
                });
                $(".stop").on("click", function () {
                    owl.trigger("stop.owl.autoplay");
                });
            }, timer);
            $(".owl-carousel").on("click", ".t_shirt_slide_color", (e) => {
                let tShirtColor = e.currentTarget.id.split("t-shirt-")[1];
                let tshirtcolorId = e.currentTarget.id.split("t-shirt-")[2];

                this.setColorCanvas(tShirtColor, tshirtcolorId);
                localStorage.setItem("active_tshirt_color", tShirtColor);
                this.$root.$emit("active_tshirt_color", tShirtColor);
            });
        } else {
            $(".carousel_center_minimum").on(
                "click",
                ".t_shirt_slide_color",
                (e) => {
                    let tShirtColor = e.currentTarget.id.split("t-shirt-")[1];
                    let tshirtcolorId = e.currentTarget.id.split("t-shirt-")[2];

                    this.setColorCanvas(tShirtColor, tshirtcolorId);
                    localStorage.setItem("active_tshirt_color", tShirtColor);
                    this.$root.$emit("active_tshirt_color", tShirtColor);
                }
            );
        }
        /* eslint-enable */
    },
    methods: {
        checkIfClassActive(val) {
            if (this.activeIndex == val) {
                return "active";
            }
        },
        setColorCanvas(tShirtColor, tshirtcolorId) {
            this.$emit("set-canvas-color", tShirtColor, tshirtcolorId);
        },
        activeClass(product_colors) {
            if (
                this.user_selected_values[this.activeColorIndex].color_id ==
                product_colors.color_id
            ) {
                return "active";
            } else if (this.checkIfClassActive(product_colors.color_id)) {
                return "active";
            } else {
                return false;
            }
        },
        activeClassHex(product_colors) {
            if (
                this.user_selected_values[this.activeColorIndex].color_hash ==
                product_colors.color_hash
            ) {
                return "active";
            } else if (this.checkIfClassActive(product_colors.color_id)) {
                return "active";
            } else {
                return false;
            }
        }
    }
};
</script>
<style>
.owl-carousel .owl-nav.disabled {
    display: block !important;
}
.carousel_center_minimum {
    display: flex;
}
.carousel_center_minimum .thumb_slider_footer {
    margin-right: 8px;
    cursor: pointer;
}
.owl-stage-outer {
    max-width: 420px;
}
.design_studio_up.product_details_update_v3
    .slider_row
    .design_studio_slider.design_slider_with_color
    .design_footer-flex {
    max-width: 100% !important;
    margin-right: 10px;
}
.design_footer-flex .color_slider {
    flex-direction: column;
    gap: 7px;
}
.owl-stage {
    flex-direction: column;
    margin-top: 20px;
}
.design_footer-flex .owl-carousel .owl-nav {
    display: none !important;
}
</style>
